import { render } from "./knowledge_search.vue?vue&type=template&id=6b11ae26&scoped=true"
import script from "./knowledge_search.vue?vue&type=script&lang=js"
export * from "./knowledge_search.vue?vue&type=script&lang=js"

import "./knowledge_search.vue?vue&type=style&index=0&id=6b11ae26&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b11ae26"]])

export default __exports__